import DeliveryView from './DeliveryView';

export default DeliveryView;
